module.exports = __webpack_public_path__ + "img/chart-active.856956d4.svg";